/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { icons } from '~/assets';
import Button from '~/components/button';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/input';
import Loading from '~/components/loading';
import TableList from '~/components/tableList';
import useApi from '~/hooks/useApi';
import { useModal } from '~/hooks/useModal';
import { ListagemHistoricoReprocessamento } from '~/models/reprocessamento-fatura';
import Endpoints from '~/services/endpoints';
import { FormField, setFormState } from '~/utils/form';
import { useInvoiceReprocess } from '../context';
import * as St from '../styles';

interface Form {
  cpf: FormField;
  numeroCartao: FormField;
  nome: FormField;
  dataInicio: FormField;
  dataFim: FormField;
}
const formInitialState = {
  cpf: { name: 'cpf', value: '' },
  numeroCartao: { name: 'numeroCartao', value: '' },
  nome: { name: 'nome', value: '' },
  dataInicio: { name: 'dataInicio', value: '' },
  dataFim: { name: 'dataFim', value: '' },
};
const InvoiceReprocessHistoricList = () => {
  const history = useHistory();
  const [list, setList] = useState([]);

  const [form, setForm] = useState<Form>(formInitialState);

  const GetHistoricList = useApi<ListagemHistoricoReprocessamento[]>({
    url: Endpoints.reprocess.getHistoricList,
    tryNewWay: true,
    fetchOnMount: false,
  });

  const onClearState = () => {
    GetHistoricList.clear();
    setForm(formInitialState);
  };
  console.log(form);
  const { openModal, closeModal } = useModal();
  const { setSolicitationData } = useInvoiceReprocess();
  const onConsultClient = async () => {
    const response = await GetHistoricList.callApi({
      cpf: form.cpf.unmasked,
      numeroCartao: form.numeroCartao?.unmasked,
      nome: form.nome?.value,
      dataInicio: form.dataInicio?.value
        ?.toString()
        .split('/')
        .reverse()
        .join('-'),
      dataFim: form.dataFim?.value?.toString().split('/').reverse().join('-'),
    });
    if (response.status !== 200) {
      openModal({
        title: 'Houve um erro',
        message: response?.mensagem,
        icon: icons.exclamation,
        positiveAction: () => {
          closeModal();
          onClearState();
        },
      });
      return;
    }
    const newList = [];

    const data = response.data;
    data.forEach((data) => {
      const item = [
        // {
        //   type: 'id',
        //   value: i++,
        //   maxChar: 5,
        //   textAlign: 'center',
        // },
        {
          border: true,
          value: data?.nomeCompleto,
          maxChar: 30,
          textAlign: 'center',
        },
        {
          value: data.dataSolicitacao
            ? moment(data.dataSolicitacao).format('DD/MM/YYYY HH:mm')
            : '',
          maxChar: 20,
          textAlign: 'center',
        },
        {
          border: true,
          value: data?.situacao,
          maxChar: 35,
          textAlign: 'center',
        },
        {
          border: true,
          value: data?.statusFatura,
          maxChar: 35,
          textAlign: 'center',
        },
        {
          value: data.dataAprovacaoRejeicao
            ? moment(data.dataAprovacaoRejeicao).format('DD/MM/YYYY HH:mm')
            : '',
          maxChar: 20,
          textAlign: 'center',
        },
        {
          border: true,
          value: data.numeroChamado,
          maxChar: 25,
          textAlign: 'center',
        },

        {
          item: data,
          searchAction: () => goToDetail(data),
        },
      ];
      newList.push(item);
    });

    setList(newList);
  };
  const customerHeader = [
    {
      id: 1,
      value: 'Nome completo',
      maxChar: 30,
      textAlign: 'left',
    },
    {
      id: 2,
      value: 'Data solicitação',
      maxChar: 30,
      textAlign: 'center',
    },
    {
      id: 3,
      value: 'Situação',
      maxChar: 30,
      textAlign: 'center',
    },
    {
      id: 4,
      value: 'Status fatura',
      maxChar: 30,
      textAlign: 'center',
    },
    {
      id: 5,
      value: 'Data aprovação/rejeição',
      maxChar: 30,
      textAlign: 'center',
    },
    {
      id: 6,
      value: 'Nr do chamado',
      maxChar: 30,
      textAlign: 'center',
    },
    {
      id: 7,
      value: 'Ação',
      maxChar: 10,
      textAlign: 'center',
    },
  ];

  const goToDetail = async (item: any) => {
    history.push('/invoice/reprocess/historic/details', item);
  };

  const disabledButton = () => {
    return (
      (form.cpf.unmasked?.length !== 11 &&
        form.numeroCartao.unmasked?.length !== 16 &&
        !form.nome?.value &&
        form.dataFim?.value?.toString()?.length !== 10 &&
        form.dataInicio?.value?.toString()?.length !== 10) ||
      GetHistoricList.loading
    );
  };
  return (
    <>
      <Loading status={GetHistoricList.loading} />

      <Container>
        <St.BoxCard>
          <ContainerFlex>
            <ContainerFlex row space>
              <ContainerFlex padding={16}>
                <Input
                  label="CPF"
                  name={form.cpf.name}
                  value={form.cpf.value}
                  onChange={(e) => setFormState(e, form, setForm)}
                  placeholder="000.000.000-00"
                  maxLength={14}
                  mask={MaskTypes.CPF}
                />
              </ContainerFlex>
              <ContainerFlex padding={16}>
                <Input
                  label="Número do cartão"
                  placeholder="0000.0000.0000.0000"
                  maxLength={19}
                  mask={MaskTypes.CREDIT_CARD}
                  onChange={(e) => setFormState(e, form, setForm)}
                  name={form.numeroCartao.name}
                  value={form.numeroCartao.value}
                />
              </ContainerFlex>
              <ContainerFlex padding={16}>
                <Input
                  label="Nome"
                  onChange={(e) => setFormState(e, form, setForm)}
                  name={form.nome.name}
                  value={form.nome.value}
                />
              </ContainerFlex>
            </ContainerFlex>
            <ContainerFlex row center horizontal>
              <ContainerFlex padding={16}>
                <Input
                  label="De"
                  placeholder="DD/MM/YYYY"
                  maxLength={10}
                  value={form.dataInicio.value}
                  name={form.dataInicio.name}
                  onChange={(e) => setFormState(e, form, setForm)}
                  mask={MaskTypes.DATE}
                />
              </ContainerFlex>

              <ContainerFlex padding={16}>
                <Input
                  label="Até"
                  placeholder="DD/MM/YYYY"
                  maxLength={10}
                  value={form.dataFim.value}
                  name={form.dataFim.name}
                  onChange={(e) => setFormState(e, form, setForm)}
                  mask={MaskTypes.DATE}
                />
              </ContainerFlex>
              <Button
                fitContent
                onClick={onConsultClient}
                loading={GetHistoricList.loading}
                disabled={disabledButton()}
              >
                <span>Consultar</span>
              </Button>
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>

        {GetHistoricList.isFetched ? (
          <St.BoxCard>
            {GetHistoricList.data?.length > 0 ? (
              <TableList customerHeader={customerHeader} list={list} />
            ) : (
              <span>Nenhum resultado encontrado</span>
            )}
          </St.BoxCard>
        ) : null}
      </Container>
    </>
  );
};

export default InvoiceReprocessHistoricList;
